module.exports = {
          srcSet: __webpack_public_path__ + "2075c04ba8dc933193a0a40e5411f3cc-47.png"+" 47w",
          images:[ {path: __webpack_public_path__ + "2075c04ba8dc933193a0a40e5411f3cc-47.png",width: 47,height: 47}],
          src: __webpack_public_path__ + "2075c04ba8dc933193a0a40e5411f3cc-47.png",
          toString:function(){return __webpack_public_path__ + "2075c04ba8dc933193a0a40e5411f3cc-47.png"},
          
          width: 47,
          height: 47
        }